import { Injectable } from '@angular/core';
import { PrivilegesProviderService } from '@bayclubs/utils';
import { PrivilegesApiService } from './privileges.api.service';
import { SubstitutionBoard } from '../../interfaces/interfaces.module';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SubBoardPrivilegesProviderService extends PrivilegesProviderService {
    public scope = 'SubBoard';

    constructor(private privileges: PrivilegesApiService) {
        super();
    }

    getPrivileges(): Observable<SubstitutionBoard.SubstitutionBoardPrivileges> {
        return this.privileges.get();
    }
}
